import { initializeAccordion } from "./helpers/initialize-accordion";

const Contents = () => {
  if (window.innerWidth < 768) {  
    initializeAccordion(".article-main__contents", ".article-main__contents-main", ".article-main__contents-title", ".article-main__contents-list-wrapper");
  }
}

export default Contents;